import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class ProfileService {

  public userProfile: any;
  public isLogin: boolean;
  public token: string;
  public userName: string;
  public constructor(private router: Router) {
  };
  getProfileInfo():void{
    var auth = JSON.parse(sessionStorage.getItem('authorizationData'));
    if(!auth){
      this.router.navigate(['/login']);
    }else{
      this.userProfile = JSON.parse(sessionStorage.getItem('profile'));
    this.token = auth.token;
    this.userName = auth.userName;
    }
    
  }
  signOut(): void {
    sessionStorage.removeItem('authorizationData');
    sessionStorage.removeItem('profile');
    this.userProfile = null;
    this.isLogin = false;
    this.token = null;
    this.userName = null;
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/profile.service.ts